const validate = (payload, setInvalidFields) => {
    console.log(payload);
    let invalids = 0;
    let fields = Object.entries(payload); // chuyển obj sang mảng  các cặp key-value, trong đó mỗi cặp được biểu diễn bằng một mảng con [key, value]([item[0], item[1]]). Điều này cho phép bạn lặp qua từng trường dữ liệu trong payload
    /* duyệt qua mảng fields. Với mỗi phần tử trong mảng fields(item), đoạn mã trong dấu ngoặc nhọn {} sẽ được thực thi. */
    fields.forEach((item) => {
        /*Nếu giá trị của trường trong là rỗng, hàm này sẽ thêm một đối tượng mới vào mảng invalidFields. Đối tượng này chứa hai thuộc tính:
        name: Tên của trường không hợp lệ (lấy từ item[0], tức là key của cặp key-value).
        message: Một thông báo lỗi mô tả rằng trường này không được bỏ trống.*/
        if (item[1] === '') {
            setInvalidFields((prev) => [
                ...prev,
                {
                    name: item[0],
                    message: 'Bạn không được bỏ trống trường này',
                },
            ]);
            invalids++;
        }
    });
    console.log(fields);
    fields.forEach((item) => {
        switch (item[0]) {
            case 'password':
                if (item[1].length < 6) {
                    setInvalidFields((prev) => [
                        ...prev,
                        {
                            name: item[0],
                            message: 'Mật khẩu phải có tối thiểu 6 kí tự',
                        },
                    ]);
                    invalids++;
                }
                break;
            case 'priceNumber':
            case 'areaNumber':
                if (+item[1] === 0) {
                    setInvalidFields((prev) => [
                        ...prev,
                        {
                            name: item[0],
                            message: 'Chưa đặt giá trị cho trường này',
                        },
                    ]);
                    invalids++;
                }
                if (!+item[1]) {
                    setInvalidFields((prev) => [
                        ...prev,
                        {
                            name: item[0],
                            message: 'Trường này phải là số',
                        },
                    ]);
                    invalids++;
                }
                break;

            default:
                break;
        }
    });
    return invalids;
};
export default validate;
